import React from 'react';
import JavascriptDomIntro from './JavascriptDomIntro.jsx';
import JavascriptDomMethods from './JavascriptDomMethods.jsx';
import JavascriptDomDocument from './JavascriptDomDocument.jsx';
import JavascriptDomElements from './JavascriptDomElements.jsx';
import JavascriptDomHtml from './JavascriptDomHtml.jsx';
import JavascriptDomForms from './JavascriptDomForms.jsx';
import JavascriptDomCss from './JavascriptDomCss.jsx';
import JavascriptDomAnimations from './JavascriptDomAnimations.jsx';
import JavascriptDomEvents from './JavascriptDomEvents.jsx';
import JavascriptDomEventListener from './JavascriptDomEventListener.jsx';
import JavascriptDomNavigation from './JavascriptDomNavigation.jsx';
import JavascriptDomNodes from './JavascriptDomNodes.jsx';
import JavascriptDomCollections from './JavascriptDomCollections.jsx';
import JavascriptDomNodeLists from './JavascriptDomNodeLists.jsx';

export default function JsHtmlDom() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS HTML DOM</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/dom/intro' className='underline'>DOM Intro</a></li>
<li><a href='/javascript/dom/methods' className='underline'>DOM Methods</a></li>
<li><a href='/javascript/dom/document' className='underline'>DOM Document</a></li>
<li><a href='/javascript/dom/elements' className='underline'>DOM Elements</a></li>
<li><a href='/javascript/dom/html' className='underline'>DOM HTML</a></li>
<li><a href='/javascript/dom/forms' className='underline'>DOM Forms</a></li>
<li><a href='/javascript/dom/css' className='underline'>DOM CSS</a></li>
<li><a href='/javascript/dom/animations' className='underline'>DOM Animations</a></li>
<li><a href='/javascript/dom/events' className='underline'>DOM Events</a></li>
<li><a href='/javascript/dom/event-listener' className='underline'>DOM Event Listener</a></li>
<li><a href='/javascript/dom/navigation' className='underline'>DOM Navigation</a></li>
<li><a href='/javascript/dom/nodes' className='underline'>DOM Nodes</a></li>
<li><a href='/javascript/dom/collections' className='underline'>DOM Collections</a></li>
<li><a href='/javascript/dom/node-lists' className='underline'>DOM Node Lists</a></li>
      </ul>
    </div>
  );
}
